import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Router } from '@angular/router';
import { Formule } from '../../../../models/formule';
import { Abonnement } from '../../../../models/abonnement';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { AbonnementFormComponent } from '../../abonnement-form/abonnement-form.component';
import { FormPaymentComponent } from '../../bills/form-payment/form-payment.component';
import { Payment } from 'src/app/models/payment';
import { FormBillsComponent } from '../../bills/form-bills/form-bills.component';
import { toastController } from '@ionic/core';
import { UserFormComponent } from '../user-form/user-form.component';
import { User } from 'src/app/micro-services/user/models/user';
import { ClientService } from 'src/app/services/client-service.service';
import { UserEleve } from 'src/app/micro-services/user/models/user-eleve';
import { SessionsService } from 'src/app/services/sessions.service';
import { SessionFormComponent } from '../../sessions/form-session/session-form.component';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { Package } from 'src/app/micro-services/packages/models/package';
import { Observable } from 'rxjs';
import { Session } from 'src/app/models/session';


@Component({
  selector: 'app-page-client',
  templateUrl: './page-client.component.html',
  styleUrls: ['./page-client.component.scss'],
})
export class PageClientComponent implements OnInit {

  public clientSelected: User;
  public formuleClientSelected: Formule;
  public isDivClicked = false;
  public abonnements: any;
  public abonnementChanged: Abonnement
  public payments: any;
  public upcomingPayments: any[] = [];
  public normalPayments: any[] = [];
  public paymentsToShow: any;
  public paymentChanged: Payment;
  showFutursPaymentsWanted: boolean = false;
  selectedTab: string = 'sessions'; // Onglet affiché par défaut

  popoverOpen = false;
  popoverEvent: any;


  public currentPage: number = 1;
  public itemsPerPage: number = 5;

  sessions: Session[] = [];
  date: string = new Date().toISOString()
  public itemsSessionsPerPage: number = 2;
  currentSessionPage: number = 1;
  showFutureSessionsWanted: boolean = true;
  package : Package;


  constructor(
    private userService: UserService,
    private ApiProviderService: ApiProviderService,
    private router: Router,
    private modalCtrl: ModalController,
    private toaster: ToastController,
    private alertController: AlertController,
    private clientService: ClientService,
    private sessionsService : SessionsService
  ) { }

  async ngOnInit() {

    this.clientSelected = this.userService.selectedClient as UserEleve;

      let user = this.userService.getUser() as UserCoach;
      user.getPackage().subscribe({
        next : (packages) => {
          this.package = packages[0];
        },
        error : (err) => {}
      });
        
    if (!this.clientSelected) {
      this.router.navigate(['coach/dashboard'])
    }
    /* this.getClientSelectedFormule(); */
    this.getClientSelectedAbonnements();
    this.getClientSelectedPayments()
    this.loadSessions();

    this.sessionsService.clientSessions$.subscribe(sessions => {
      this.sessions = sessions;
    });

  }

  /* getClientSelectedFormule(){
    if (this.clientSelected && this.clientSelected.formuleId) {
      this.ApiProviderService
        .getFormuleById(this.clientSelected.formuleId)
        .subscribe((res : Formule) => {
         this.formuleClientSelected = res;
        });
    }
  } */

  getClientSelectedAbonnements() {
    if (this.clientSelected) {
      this.ApiProviderService.getAbonnementByClient(this.clientSelected.id)
        .subscribe((res: Payment[]) => {
          res.sort((a, b) => new Date(a.datePaiement).getTime() - new Date(b.datePaiement).getTime());
          this.abonnements = res.map(abonnement => {
            const expandedAbonnement = { ...abonnement, isExpanded: false };
            return expandedAbonnement;
          });
          if (this.abonnementChanged) {
            this.abonnements.forEach(abonnement => {
              if (abonnement.id === this.abonnementChanged.id) {
                abonnement.isExpanded = true;
              }
            });
          }
        });
    }
  }

  getClientSelectedPayments() {
    if (this.clientSelected) {
      this.ApiProviderService.getPaymentsByClient(this.clientSelected.id)
        .subscribe((res: any) => {
          // Reset the lists
          this.upcomingPayments = [];
          this.normalPayments = [];
  
          this.payments = res.map(payment => {
            const expandedPayment = { ...payment, isExpanded: false };
            return expandedPayment;
          });
  
          // Separate the payments into upcoming and normal
          this.payments.forEach(payment => {
            if (payment.type === 0) {
              this.normalPayments.push(payment);
            } else if (payment.type === 1) {
              this.upcomingPayments.push(payment);
            }
          });
  
          // Initialize the displayed payments list
          this.paymentsToShow = this.normalPayments;
  
          // Check if this.paymentChanged is defined before using it
          if (this.paymentChanged) {
            this.payments.forEach(payment => {
              if (payment.id === this.paymentChanged.id) {
                payment.isExpanded = true;
              }
            });
          }
  
        // Update displayed payments based on the selected filter
        if (this.showFutursPaymentsWanted) {
          this.updateDisplayedPayments(this.upcomingPayments);
        } else {
          this.updateDisplayedPayments(this.normalPayments);
        }
        });
    }
  }


  toggleDetails(expended: any) {
    expended.isExpanded = !expended.isExpanded;
  }



  async openAbonnementForm() {
    try {
      const modal = await this.modalCtrl.create({
        component: AbonnementFormComponent,
      });
      modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm') {
        this.getClientSelectedAbonnements();
      }
    } catch (error) {
      // Gestion de l'erreur
      console.error('Une erreur s\'est produite lors de l\'ouverture du formulaire d\'abonnement:', error);
      // Afficher un message d'erreur à l'utilisateur ou prendre d'autres mesures appropriées
    }
  }

  activeAbonnement(abonnement: Abonnement) {
    if (abonnement) {
      this.ApiProviderService
        .activeOrDesacAbonnement(abonnement)
        .subscribe((res: any) => {
          this.abonnementChanged = abonnement;
          this.abonnementChanged.isExpanded = true;
          this.getClientSelectedAbonnements()
        });
    }
  }

  async openModal(abonnement: Abonnement = null) {
    const modal = await this.modalCtrl.create({
      component: FormPaymentComponent,
      componentProps: {
        abonnement: abonnement,
        client: this.clientSelected,
        abonnements: this.abonnements
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm') {
      this.getClientSelectedPayments();
      this.presentSuccessToast("Paiement ajouté avec succès !")
    }
  }

  async openModalBill() {
    const modal = await this.modalCtrl.create({
      component: FormBillsComponent,
      componentProps: {
        client: this.clientSelected,
        abonnements: this.abonnements
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm') {
      this.presentSuccessToast("Facture enregistrée sur votre téléphone !")
    }
  }

  //Pagination payments

  showPayments() {
    this.showFutursPaymentsWanted = false;
    this.currentPage = 1;
    this.updateDisplayedPayments(this.normalPayments);
  }
  
  showFutursPayments() {
    this.showFutursPaymentsWanted = true;
    this.currentPage = 1;
    this.updateDisplayedPayments(this.upcomingPayments);
  }

  nextPage(paymentList: any) {
    this.currentPage++;
    this.updateDisplayedPayments(paymentList);
  }
  
  previousPage(paymentList: any) {
    this.currentPage--;
    this.updateDisplayedPayments(paymentList);
  }
  
  updateDisplayedPayments(paymentList: any) {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paymentsToShow = paymentList.slice(startIndex, endIndex);
  }

  async presentSuccessToast(message: string) {
    const toast = await this.toaster.create({
      message: message,
      duration: 3000, // Durée du toast en millisecondes (par exemple, 3000 ms = 3 secondes)
      position: 'bottom', // Position du toast (top, middle, bottom)
      color: 'success', // Couleur du toast (peut être success, warning, danger, etc.)
    });
    toast.present();
  }

  deleteClient() {
    this.ApiProviderService.deleteClient(this.clientSelected).subscribe(
      (res: any) => {
        
      },
      (err) => {
        console.log("erreur lors de la suppression")
      }
    );
  }

  modalEdit(client: User = null) {
    const title = "Modifier ce client";
    this.openModalModify(title);
  }

  async openModalModify(title: string) {
    const modal = await this.modalCtrl.create({
      component: UserFormComponent,
      componentProps: {
        foo: this.clientSelected,
        title: title
      }
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

  async changeClientStatut() {
    if (this.clientSelected.isActive) {
      this.clientSelected.isActive = false;



      this.ApiProviderService.editClient(this.clientSelected).subscribe({
        next: res => {
          this.updateClientList();
        },
        error: async err => {
          this.clientSelected.isActive = true;
          const alert = await this.alertController.create({
            header: 'Information',
            message: err.error,
            buttons: [
              {
                text: 'OK',
                role: "ok"
              }
            ]
          });

          alert.present()

          console.log(err)
        }
      })
    } else {

      const alert = await this.alertController.create({
        header: 'Confirmation',
        message: 'Ce client sera activé pour une durée de 7 jours',
        buttons: [
          {
            text: 'Annuler',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (cancel) => {
            }
          }, {
            text: 'OK',
            role: "ok",
            handler: () => {
            }
          }
        ]
      });

      await alert.present();

      let {role, data} = await alert.onWillDismiss();

      if(role == "ok"){
        this.clientSelected.isActive = true;
        this.ApiProviderService.editClient(this.clientSelected).subscribe({
          next: async res => {
            this.updateClientList();
            let toast = await this.toaster.create({
              message : "Success",
              color : "success",
              duration : 2000
            });

            await toast.present();
          },
          error: err => {
            console.log(err);

          }
        })
      }

    }

  }

  async confirmInactifClient() {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      message: 'Êtes-vous sûr de vouloir rendre ce client inactif ?',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (cancel) => {
          }
        }, {
          text: 'OK',
          handler: () => {
            this.changeClientStatut()
          }
        }
      ]
    });

    await alert.present();
  }

  updateClientList() {
    let coach = this.userService.getUser();
    let coachId = coach.id;
    this.ApiProviderService.getUsersByCoach(coachId).subscribe(
      (res) => {
        // Utiliser le service pour mettre à jour la liste des clients
        this.clientService.updateClients(res);
      },
      (err) => {
        console.log("Erreur lors de la récupération de la liste des clients", err);
      }
    );
  }

  //SESSIONS 

  getSessionsByCoachByClient(){

  }

  async openSessionForm() {
    try {
      const modal = await this.modalCtrl.create({
        component: SessionFormComponent,
        componentProps: {
          client: this.clientSelected // Passe le client sélectionné ici
        }
      });
      modal.present();
  
      const { data, role } = await modal.onWillDismiss();
  
      if (role === 'confirm') {
        this.loadSessions()
      }
    } catch (error) {
      // Gestion de l'erreur
      console.error('Une erreur s\'est produite lors de l\'ouverture du formulaire de session:', error);
      // Afficher un message d'erreur à l'utilisateur ou prendre d'autres mesures appropriées
    }
  }

  loadSessions(): void {
    const currentDate = new Date().toISOString();
    this.sessionsService.getSessionsByClientByCoach(
      this.userService.user.id,
      this.clientSelected.id,
      currentDate,
      this.currentSessionPage,
      this.itemsSessionsPerPage,
      this.showFutureSessionsWanted // Passer le booléen showFutureSessions
    )
  }

  showFutureSessions(): void {
    this.showFutureSessionsWanted = true;
    this.loadSessions();
  }
  
  showPastSessions(): void {
    this.showFutureSessionsWanted = false;
    this.loadSessions();
  }



  nextSessionsPage(): void {
    this.currentSessionPage++;
    this.loadSessions();
  }

  previousSessionsPage(): void {
    if (this.currentSessionPage > 1) {
      this.currentSessionPage--;
      this.loadSessions();
    }
  }

  //PopOver
  openPopover(ev: Event) {
    this.popoverEvent = ev;
    this.popoverOpen = true;
  }

}
